/*
Item: components for displaying a labeled dropdown frontend form component (like Labeled Fields)
Name: DropdownLabeled
Format: Code/Frontend component
*/
/* eslint-disable react/jsx-props-no-spreading */

import React, { Component } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';

// class wrapper for prime react Dropdown component, adds label to Dropdown component
export class DropdownLabeled extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { customClass, containerStyle } = this.props;
    const { label } = this.props;
    return (
      <div className={customClass} style={containerStyle}>
        <span
          className="p-float-label"
          style={{
            fontSize: '12px',
            color: '#898989',
          }}
        >
          {label}
        </span>
        <Dropdown {...this.props} />
      </div>
    );
  }
}

// class wrapper for prime react Dropdown component, adds label to Dropdown component
export class MultiSelectLabeled extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { customClass } = this.props;
    const { label } = this.props;
    return (
      <div className={customClass}>
        <span
          className="p-float-label"
          style={{
            fontSize: '12px',
            color: '#898989',
          }}
        >
          {label}
        </span>
        <MultiSelect {...this.props} />
      </div>
    );
  }
}
